<template>
  <div class="contact-group-class">
    Please email
    <a
      href="mailto:rewardingdogtrain@gmail.com"
      target="_blank"
      class="mailto-link"
      :style="{color: this.$themes.info}"
    >
      rewardingdogtrain@gmail.com
    </a>
    if there were any problems when attempting to sign up for a class. Your spot is not reserved until payment of the class is received.
  </div>
</template>

<script>

export default {
  name: 'contact-group-class',
}
</script>

<style scoped lang="scss">
.contact-group-class {
  margin: 2rem 0;
}
</style>
